"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function StorytellingApproach() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="222529" id="radiofrequencytreatment" className="bg-background w-full overflow-hidden text-foreground">
      <div className="flex flex-col md:flex-row w-full min-h-[600px]">
        {}
        <div className="w-full md:w-[40%] relative min-h-[400px] md:min-h-auto">
          <img src="https://stable-sturgeon.10web.cloud/wp-content/uploads/2026/05/header-face-e415eb00.jpg" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1642411/img/radiofrequency_treatment_luxe.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1642411/img/radiofrequency_treatment_luxe.png-wvc-sizes" alt="Professionelle Radiofrequenz-Behandlung in der DERMA Beauty Lounge" className="absolute inset-0 w-full h-full object-cover" loading="lazy" decoding="async" />
        </div>

        {}
        <div ref={ref} className="w-full flex flex-col justify-center px-6 py-20 transition-all duration-1000 ease-out opacity-100 translate-y-0 !bg-[rgba(245,245,245,1)] md:w-[60%] md:py-24 md:pl-[10%] lg:pl-[15%] md:pr-12 lg:pr-24">
          <span className="font-default uppercase tracking-widest mb-6 text-primary block !text-xl">
            Non-Invasiv & Effektiv
          </span>
          <h2 className="font-default font-bold leading-tight mb-8 !text-[rgba(4,126,114,1)] !text-5xl">Radiofrequenz – Behandlung für zeitlose Jugendlichkeit.</h2>
          <p className="text-lg md:text-[22px] font-sans text-muted-foreground leading-relaxed mb-10">
            Erleben Sie die Synergie aus High-Tech und Ästhetik. Unsere Radiofrequenz-Technologie stimuliert die hauteigene Kollagenproduktion in der Tiefe, um Ihre Konturen sanft zu straffen und das Hautbild nachhaltig zu verfeiner – ganz ohne Ausfallzeiten.
          </p>
          <div>
            <a href="https://wa.me/491713617469" target="_blank" className="inline-flex items-center justify-center border border-primary text-primary px-8 py-3 rounded-lg font-medium transition-all hover:bg-primary hover:text-white">
  Termin sichern
          </a>
          </div>
        </div>
      </div>
    </section>;
}